
const Footer = (props) => {
  return (
    <footer className="pt-4 pb-4 text-center">
      <div className="container">
        <p className="mt-0 mb-0">© Copyright {new Date().getFullYear()} RK-Restra. All Rights Reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
